import * as React from 'react';
import * as TreeView from 'react-treeview';
import DiagnosticsConfig from './diagnosticsConfig';
import MonitoringModeConfig from './monitoringModeConfig';
import ScanScheduleConfig from './scanScheduleConfig';
import VODConfig from './vodConfig';
import AWSConfig from './awsConfig';
import GlobalAlarmConfig from './globalAlarmConfig';
import AppleStreamingConfig from './appleStreamingConfig';
import MicrosoftStreamConfig from './microsoftStreamConfig';
import AdobeStreamConfig from './adobeStreamConfig';
import MPEGAdaptiveStreamConfig from './mpegAdaptiveStreamConfig';
import PlaylistManifestValidationConfig from './playlistManifestValidationConfig';
import DRMConfig from './drmConfig';
// import PlayReadyConfig from './playReadyConfig';
// import WidevineConfig from './widevineConfig';
import '../../../css/App.css';
import OAuthClient from '../../../api';

// const _ = require('lodash');
interface Props {

}
class State {
    collapsedBookkeeping: any;
    data: any;
    currentIndex: number;
    parentIndex: number;
    VODLicensePresent: boolean;
    VODOnlyLicensePresent: boolean;
}

export default class MonitorConfigView extends React.Component<Props, State> {

    componentWillMount() {
        // SAN-4530
        let vodOnly = false;
        if (!OAuthClient.storage) {
            // tslint:disable-next-line:no-console
            console.log('OAuth storage disabled');
            this.setState({
              VODLicensePresent: false,
              VODOnlyLicensePresent: false
            });
        } else {
            // retrieve the oauth information as a string from session storage
            let dataStr = OAuthClient.storage.getItem('oauth');
            let data1 = dataStr && JSON.parse(dataStr);
            if (data1 && data1.key) {
                // move the data to the state
                let { VODLicensePresent, VODOnlyLicensePresent } = data1;
                this.setState({
                  VODLicensePresent: VODLicensePresent,
                  VODOnlyLicensePresent: VODOnlyLicensePresent
                });
                vodOnly = VODOnlyLicensePresent;
            }
        }
        let data;
        if (vodOnly) {
            data = [
                {
                    type: 'Global Parameters',
                    options: [
                        'Monitoring', 'Playlist/Manifest Validation', 'Diagnostics', 'VOD', 'AWS'
                    ],
                },
                {
                    type: 'Protocol Configuration',
                    options: [
                        'Apple / HTTP Live Streaming', 'MPEG / Dynamic Adaptive Streaming', 'Microsoft / Smooth Streaming'
                    ],
                },
                {
                    type: 'Decryption',
                    options: [
                        'DRM System' // , 'PlayReady', 'Widevine'
                    ],
                },
                {
                    type: 'Global Alarms',
                    options: []
                }
            ];
        } else {
            data = [
                {
                    type: 'Global Parameters',
                    options: [
                        'Monitoring', 'Playlist/Manifest Validation', 'Scan/Schedule', 'Diagnostics', 'VOD', 'AWS'
                    ],
                },
                {
                    type: 'Protocol Configuration',
                    options: [
                        'Apple / HTTP Live Streaming', 'MPEG / Dynamic Adaptive Streaming', 'Microsoft / Smooth Streaming',
                        'Adobe / HTTP Dynamic Streaming'
                    ],
                },
                {
                    type: 'Decryption',
                    options: [
                        'DRM System' // , 'PlayReady', 'Widevine'
                    ],
                },
                {
                    type: 'Global Alarms',
                    options: []
                }
            ];
        }

        this.setState({
            collapsedBookkeeping: [false, true, true, true],
            data: data,
            currentIndex: 0,
            parentIndex: 0
        });
        this.handleClick = this.handleClick.bind(this);
    }

    renderRightPanel(selectedOption: string) {
        switch (selectedOption) {
            case 'Monitoring':
                return <MonitoringModeConfig />;
            case 'Scan/Schedule':
                return <ScanScheduleConfig />;
            case 'Diagnostics':
                return <DiagnosticsConfig />;
            case 'VOD':
                return <VODConfig />;
            case 'AWS':
            	return <AWSConfig />;
            case 'Playlist/Manifest Validation':
                return <PlaylistManifestValidationConfig />;
            case 'Apple / HTTP Live Streaming':
                return <AppleStreamingConfig />;
            case 'Microsoft / Smooth Streaming':
                return <MicrosoftStreamConfig />;
            case 'Adobe / HTTP Dynamic Streaming':
                return <AdobeStreamConfig />;
            case 'MPEG / Dynamic Adaptive Streaming':
                return <MPEGAdaptiveStreamConfig />;
            case 'Global Alarms':
                return <GlobalAlarmConfig />;
            case 'DRM System':
                return <DRMConfig />;
            case 'PlayReady':
                return '';
            case 'Widevine':
                return '';
            default:
                return <MonitoringModeConfig />;
        }
    }

    handleClick(parentIndex: number) {
        let [...collapsedBookkeeping] = this.state.collapsedBookkeeping;
        collapsedBookkeeping[parentIndex] = !collapsedBookkeeping[parentIndex];
        if (parentIndex === 3 ) {
            this.setState({collapsedBookkeeping: collapsedBookkeeping, parentIndex: parentIndex});
        }
        this.setState({collapsedBookkeeping: collapsedBookkeeping});
    }

    handleOptionsClick(parentIndex: number, index: number) {
        this.setState({
            currentIndex: index,
            parentIndex: parentIndex
        });
    }

    render() {

        let selectedOption: string = (this.state.data !== undefined && this.state.parentIndex !== undefined)
            ? this.state.data[this.state.parentIndex].type === 'Global Alarms'
                ? this.state.data[this.state.parentIndex].type
                : this.state.data[this.state.parentIndex].options[this.state.currentIndex]
            : null;
        const collapsedBookkeeping = this.state.collapsedBookkeeping;
        return (
            <React.Fragment>
            <div className="view-content min-width1350" id="systemConfig">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Monitor Configuration</div>
                        </div>
                    </div>

                </div>
                <div className="view-clientarea">
                    <div className="divided-area-main">
                        <div className="sysConfig-left-panel">
                            {this.state.data.map((node: any, i: number) => {
                                const label =
                                    <span className="node" onClick={() => this.handleClick(i)}>
                                        {node.type}
                                    </span>;
                                if (node.options.length === 0) {
                                    return (<div className="tree-view_item">
                                        <span className="node tree-view_item_empty" onClick={() => this.handleClick(i)}>
                                                {node.type}
                                        </span>
                                    </div>);
                                } else {
                                    return (
                                        <TreeView
                                            key={i}
                                            nodeLabel={label}
                                            collapsed={collapsedBookkeeping[i]}
                                            onClick={() => this.handleClick(i)}
                                            // disableSelection={node.type === 'Global Alarms'}
                                        >
                                            {node.options.map((entry: any, index: number) => {
                                                if ((!this.state.VODLicensePresent && !this.state.VODOnlyLicensePresent) && entry === 'VOD') {
                                                    return null;
                                                } else {
                                                    return (
                                                        <div
                                                            className={`card${(this.state.currentIndex === index && this.state.parentIndex === i) ? ' selected' : ''}`}
                                                            key={entry}
                                                            onClick={() => this.handleOptionsClick(i, index)}
                                                        >
                                                            {entry}
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </TreeView>
                                    );
                                }
                            })}
                        </div>
                        <div className="view-content config-view flow sysConfig-right-panel vertical-flex-parent" id="asset-alias">
                            {this.renderRightPanel(selectedOption)}
                        </div>
                    </div>
                </div>
            </div>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/monitorConfig.tsx